import axios from 'axios';
import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import {AccountFilter, AccountItem, AccountsState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<AccountsState, RootState> ={
  getAccounts: ({commit, dispatch},data:AccountFilter) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/lk-api/accounts',params: data})
        .then(resp => {
          commit('setAccounts', resp.data.accounts);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getAccountItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/lk-api/accounts/${id}`})
        .then((resp:any) => {
          let accountItem = <AccountItem>resp.data;
          accountItem.id = id;
          commit('setAccountItem', accountItem);
          resolve(accountItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  saveAccount: ({commit, dispatch}, data:AccountItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      //@ts-ignore
      if (data.id) data.account_id = data.id
      axios({
        method: data.id ? 'post' : 'post',
        url: '/lk-api/accounts/' + (data.id ? 'edit' : ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getAccounts');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deleteAccount: ({commit, dispatch}, data:AccountItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: `/lk-api/accounts/delete?account_id=${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getAccounts');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  exportAccounts: ({commit, dispatch}, data: AccountFilter) => {
    return directDownload('/lk-api/accounts/export', data)
  },
};
